function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPurchaseHistoryRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 27a1.5 1.5 0 10-.001 2.999A1.5 1.5 0 007.5 27zM14.5 27a1.5 1.5 0 10-.001 2.999A1.5 1.5 0 0014.5 27zM14.734 19l-.5 4H7.636l-.727-4h7.825zM6 14H2v2h2.336l1.663 8.994L6 25h10l1-8H6.545L6 14z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 2C12.925 2 8 6.925 8 13c0 .396.023.785.063 1.17l.152.83h2.017A8.978 8.978 0 0110 13c0-4.963 4.037-9 9-9s9 4.037 9 9c0 4.962-4.037 9-9 9-.205 0-.404-.017-.605-.031l-.249 1.988c.283.022.566.043.854.043 6.075 0 11-4.925 11-11S25.075 2 19 2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8v7h8v-2h-6V8h-2z",
    fill: props.color
  }));
}

export default SvgIconPurchaseHistoryRexOutline;